/**
 * A file shown in the FileSelectDropdown.
 *
 * Identity and display name each have two possible source fields, depending on
 * whether the file came from a patient's `data_objects` (obj_*) or from the
 * clinical parallel-array shape (id / file_name). Resolve them in this order:
 *   id   → obj_id ?? id
 *   name → obj_name ?? file_name
 * Use `getPatientFileId` / `getPatientFileName` rather than reaching for a
 * single field. `file_exists` is optional; only an explicit `false` marks a
 * file as missing on disk. Likewise only an explicit `is_reviewable: false`
 * marks a file the review surface cannot open (an EDF without usable EEG).
 */
export interface PatientFile {
    id?: number
    obj_id?: number
    file_name?: string
    obj_name?: string
    obj_type?: string
    filesize?: number
    start_time?: number | string | null
    end_time?: number | string | null
    timezone?: string | null
    file_exists?: boolean
    is_reviewable?: boolean
}

export function getPatientFileId(file: PatientFile): number | undefined {
    return file.obj_id ?? file.id ?? undefined
}

export function getPatientFileName(file: PatientFile): string {
    return file.obj_name ?? file.file_name ?? ""
}

export function patientFileExists(file: PatientFile): boolean {
    return file.file_exists !== false
}

export function patientFileIsReviewable(file: PatientFile): boolean {
    return file.is_reviewable !== false
}

export function patientFileIsSelectable(file: PatientFile): boolean {
    return patientFileExists(file) && patientFileIsReviewable(file)
}
